import { Summary } from '@livekatsomo/models';
import { generateHTMLFromEditorContent } from '@livekatsomo/web/ui-components/editor';
import Box, { BoxProps } from '@mui/material/Box';

/**
 * Props for the SummaryView component.
 */
export interface SummaryViewProps extends BoxProps {
  summary: Summary;
}

/**
 * Renders a summary view component.
 * @param props - The props for the component.
 * @returns  - The summary view component.
 */
export function SummaryView({ summary }: SummaryViewProps) {
  if (!summary?.document) return null;
  const output = generateHTMLFromEditorContent(summary.document);
  return (
    <Box
      sx={{
        overflow: 'auto',
        '.image-wrapper img': { display: 'block' },
        '.image-float-left': {
          marginRight: 2,
        },
        '.image-float-right': {
          marginLeft: 2,
        },
        a: {
          color: (theme) => theme.palette.primary.main,
        },
      }}
      dangerouslySetInnerHTML={{ __html: output }}
    />
  );
}

export default SummaryView;
